const Demo6CTA11 = ({ isAuthenticated, onRegister, onDashboard }) => {
    const handleClick = () => {
        if (isAuthenticated) {
            onDashboard();
        } else {
            onRegister();
        }
    };

    return (
        <section id="cta" className="cta-section division">
            <div className="container">
                <div className="bg-tra-purple cta-11-wrapper">
                    <div className="row d-flex align-items-center">
                        <div className="col-lg-7 col-lg-7">
                            <div className="cta-11-txt">
                                <h2 className="h2-xs">Ready to Join OLMO?</h2>
                                <p className="p-lg">
                                    Donec vel sapien augue integer urna vel turpis cursus porta, mauris augue luctus dolor velna auctor congue tempus
                                </p>
                                <button type="button" className="btn btn-stateblue tra-stateblue-hover" onClick={handleClick}>
                                    {isAuthenticated ? 'Go to Dashboard' : 'Get Started Now'}
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="text-end">
                                <div className="cta-11-img text-center">
                                    <img className="img-fluid" src="/images/demo6/img-25.png" alt="cta" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6CTA11;
